<template>
  <section class="f-30" ref="root">
    <div ref="bg" class="alive_bg">
      <div class="alive_small_title f-center-title">
        <div class="small_title">Alive 壁纸</div>
        <div class="small_sub_title">动静皆宜，好看又好玩</div>
      </div>
      <div class="alive_bg_mask" v-bg bg-url="@/v2/auto/assets/image/30/bg.jpg">
        <div class="video_container" ref="videoContainer">
          <div class="video_screen">
            <m-video
              ref="video"
              class="alive_video"
              disablepictureinpicture
              playsinline
              webkit-playsinline
              muted
              src="@/v2/auto/assets/video/30/0.mp4"
            />
            <m-img class="mask_screen" src="@/v2/auto/assets/image/30/0.png" />
          </div>
          <replay @click="replayVideo($refs.video)" />
          <div class="title-content">
            <div class="bottom_title f-center-title">生长</div>
            <div class="bottom_sub_title f-center-sub-title">
              车辆充电时花朵逐渐绽放，耗电时逐渐闭合，让用户直观感受到能量的流动与变化
            </div>
          </div>
        </div>
      </div>
      <div class="mask_text_svg">Alive</div>
    </div>
  </section>
</template>
<script>
import { replayVideo, videoPlayByVisibleArea, matchMedia } from '@/utils'
import replay from '@/components/replay.vue'
import { resizeHandle } from '@/v2/auto/bus_key'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      width: matchMedia(),
      progress: 0,
    }
  },
  methods: {
    replayVideo,
    setVideoContainerWidth(tl, label = 'zoomOut') {
      const progress = (this.progress - tl.labels[label]) * 2
      const clientWidth = Math.max(document.documentElement.clientWidth, 1200)
      const width = clientWidth - (clientWidth - this.width) * progress
      this.$gsap.set('.video_container', { width: `${width}px` })
    },
  },
  mounted() {
    const video = this.$refs.video
    // 监听屏幕宽度变化
    video && videoPlayByVisibleArea(video)
    // 初始设置一下高度，避免浏览器大小变化时不会动态变化
    this.$gsap.set('.video_screen', { minHeight: '100vh' })
    const tl = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.alive_bg',
        start: 'top top',
        end: 'bottom top',
        pin: true,
        scrub: 1,
        snap: {
          snapTo: 'labelsDirectional', //
          duration: { min: 0, max: 1.2 },
          delay: 0,
          inertia: false,
        },
        onUpdate: (self) => {
          this.progress = self.progress
          // 避免上滑时宽高设置末端不撑满屏幕
          if (self.progress < 0.5) {
            this.$gsap.set('.video_container', {
              width: `${Math.max(
                document.documentElement.clientWidth,
                1200,
              )}px`,
            })
            this.$gsap.set('.video_screen', { minHeight: '100vh' })
          }
          if (self.progress === 1) {
            // 滑动完成后动态计算根布局高度,避免内容截断
            const videoContainer = this.$refs.videoContainer
            if (videoContainer) {
              const rect = videoContainer.getBoundingClientRect()
              const height = `calc(200vh + ${rect.height + 230}px)`
              this.$gsap.set(this.$refs.root, { height })
            }
          }
        },
      },
    })
    tl.addLabel('start')
    tl.to(
      '.mask_text_svg',
      {
        ease: 'power3.in',
        scale: 80,
        x: '100%',
        opacity: 0,
      },
      'start',
    )
    tl.addLabel('zoomOut')
    tl.to(
      '.video_screen',
      {
        borderRadius: 20,
        minHeight: '0',
        onUpdate: () => {
          this.setVideoContainerWidth(tl)
        },
      },
      'zoomOut',
    )
    tl.to(
      '.video_container',
      {
        marginTop: 230,
      },
      'zoomOut',
    )
    tl.to(
      '.mask_screen',
      {
        opacity: 1,
        ease: 'power2.in',
      },
      'zoomOut',
    )
    tl.to(
      '.alive_small_title',
      {
        opacity: 1,
      },
      'zoomOut',
    )
    tl.addLabel('end')
    this.$event.on(resizeHandle, () => {
      const clientWidth = document.documentElement.clientWidth
      if (clientWidth <= 1680) {
        this.width = 880
      } else if (clientWidth <= 1920) {
        this.width = 1000
      } else {
        this.width = 1200
      }
      this.setVideoContainerWidth(tl)
      if (isPad) {
        this.$gsap.set('.video_screen', { height: `${window.innerHeight}px` })
      }
    })
  },
}
</script>
<style lang="less" scoped>
.f-30 {
  width: 100%;
  background-color: black;
  position: relative;
  height: 300vh;

  .alive_bg {
    position: absolute;
    height: 200vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .alive_bg_mask {
      background-size: 100% 100%;
      background-position: top;
      background-repeat: no-repeat;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .alive_small_title {
      position: absolute;
      top: 50px;
      z-index: 0;
      opacity: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 700;

      .small_title {
        background: radial-gradient(
          32.55% 65.56% at 49.68% 12.22%,
          #4e40be 0%,
          #9a8deb 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        line-height: 70px;
      }

      .small_sub_title {
        color: white;
      }
    }
    .video_container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;
      align-items: flex-end;
      color: white;
      width: 100%;
      background-size: 100% 100%;
      background-position: top;
      background-repeat: no-repeat;
      position: relative;
      @media screen and (max-width: 2560px) {
        min-width: 1200px;
      }
      @media screen and (max-width: 1980px) {
        min-width: 1000px;
      }
      @media screen and (max-width: 1680px) {
        min-width: 880px;
      }
      .video_screen {
        width: 100%;
        min-height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        position: relative;
        .alive_video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .mask_screen {
          position: relative;
          z-index: 1;
          opacity: 0;
          width: 100%;
          height: 100%;
          aspect-ratio: 16/10;
          object-fit: cover;
          pointer-events: none;
        }
      }

      .title-content {
        margin-bottom: 100px;
        width: 100%;
        .bottom_title {
          margin-bottom: 16px;
          color: #ffffff;
          font-weight: 600;
          line-height: 66px;
          text-align: center;
        }

        .bottom_sub_title {
          color: #ffffffcc;
          line-height: 28px;
          text-align: center;
        }
      }
    }
    .mask_text_svg {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      font-size: 220px;
      font-weight: 600;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: black;
      pointer-events: none;
      transform: scale(2);
      height: 100vh;
      mix-blend-mode: darken;
      @media screen and (max-width: 1680px) {
        font-size: 180px;
        font-weight: 500;
      }
    }
  }
}
</style>
